import { createContext } from 'react';
import {
  IAuthContext,
  IGlobalConfig,
  IApiContext,
  IAnalyticsContext,
  ILocaleContext,
  ITranslationContext,
  PluginContextType,
} from '~/common/types';

export const ApiContext = createContext<IApiContext | undefined>(undefined);

export const ConfigContext = createContext<IGlobalConfig | undefined>(
  undefined,
);

export const ApplicationContext = createContext<IAuthContext | undefined>(
  undefined,
);
export const DebugContext = createContext<boolean>(false);

export const AnalyticsContext = createContext<IAnalyticsContext | undefined>(
  undefined,
);

export const LocaleContext = createContext<ILocaleContext | undefined>(
  undefined,
);

export const TranslationContext = createContext<
  ITranslationContext | undefined
>(undefined);

export const PluginContext = createContext<PluginContextType>({
  isPluginReady: false,
  pluginError: null,
  enabledPlugins: {
    navbar: false,
    footer: false,
    sidebar: false,
  },
  testPlugin: async () => {},
  resetPlugin: () => {},
  isTestingPlugin: false,
  scriptUrl: undefined,
  api: {
    onAddToCart: undefined,
  },
});
